<template>
  <div>
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">
            Stickers <span class="badge badge-primary">{{ count }}</span>
          </h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <button
            class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
            @click="openAddStickerModal()"
          >
            <i class="fas fa-plus"></i> Add new Sticker
          </button>
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Stickers
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-4">
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn waves-effect waves-light btn-info"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search"
                      @change="search()"
                      v-model="textSearch"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Name</th>
                      <th>Images</th>
                      <th>Text</th>
                      <th>Button text</th>
                      <th>URL</th>
                      <th>Active</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :key="index"
                      v-for="(item, index) in items"
                    >
                      <td>{{ item.id }}</td>
                      <td>{{ item.name }}</td>
                      <td><img :src="item.image" :alt="item.name" width="60"/></td>
                      <td>{{ item.text }}</td>
                      <td>{{ item.buttonText }}</td>
                      <td>
                        {{ item.buttonUrl }}
                      </td>
                      <td>
                        <i :class="['fa fa-circle', item.active ? 'text-success' : 'text-danger' ]"></i>
                      </td>
                      <td>
                        <a class="mr-2" href="#" @click.prevent="editSticker(item)">Edit</a>
                        <a href="#" @click="deleteSticker(item)">Delete</a>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="overflow-auto">
                  <b-pagination
                    v-model="page"
                    :total-rows="count"
                    :per-page="size"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="create-sticker-modal"
      hide-footer
      title="Create new sticker"
      id="create-sticker-modal"
    >
    <form class="needs-validation" @submit.prevent="createSticker">
        
        <div class="d-block form-group">
          <label for="text">Image</label>
          <div>
            <img v-if="createStickerForm.image" :src="createStickerForm.image" width="60" />
            <input type="file" class="form-control" @change="onChangeSticker" accept="image/*" required />
          </div>
        </div>
        <div class="d-block form-group">
          <label for="name">Name</label>
          <div>
            <input class="form-control" type="text" v-model="createStickerForm.name" name="text" required />
          </div>
        </div>
        <div class="d-block form-group">
          <label for="buttonUrl">Button URL</label>
          <div>
            <input class="form-control" type="text" v-model="createStickerForm.buttonUrl" name="buttonUrl" required>
          </div>
        </div>
        <StickerTab  :currentCondition="createStickerForm.currentCondition" @updateCurrentCondition="updateCurrentCondition" />
        <div class="form-group" v-show="createStickerForm.currentCondition === 'rule'">
          <div>
            <textarea
              class="form-control"
              type="text"
              v-model="createStickerForm.rule"
              name="rule" rows="3"
            />
          </div>
        </div>
        <div class="form-group" v-show="createStickerForm.currentCondition === 'emails'">
          <div>
            <span><i>Needs to be separated by a newline.</i></span>
            <textarea
              placeholder="example@example.com
example02@example@example.com"
              class="form-control"
              type="text"
              v-model="createStickerForm.emails"
              name="emails"
              rows="3"
            />
          </div>
        </div>
        <div class="form-group" v-show="createStickerForm.currentCondition === 'userIds'">
          <div>
            <span><i>Needs to be separated by a newline.</i></span>
            <textarea
              placeholder="123
456"
              class="form-control"
              type="text"
              v-model="createStickerForm.userIds"
              name="userIds"
              rows="3"
            />
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="mr-2 btn btn-primary">
            Create Sticker
            <i class="fa fa-spinner fa-spin" v-if="isCreatingSticker"></i>
          </button>
          <button type="button" class="btn btn-light" @click="hideAddStickerModal">Cancel</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import StickerApi from "@/api/sticker"
import {mapState} from 'vuex'
import StickerTab from "./StickerTab.vue"
import utils  from "@/utils"

export default {
  data() {
    return {
      items: [],
      page: 1,
      size: 10,
      count: 0,
      isLoading: false,
      textSearch: "",
      isCreatingSticker: false,
      createStickerForm: {
        name: '',
        text: '',
        buttonText: '',
        buttonUrl: '',
        image: '',
        rule: '',
        active: true,
        userId: null,
        emails: '',
        userIds: '',
        currentCondition: 'rule',
      },
      conditions: ['rule', 'emails', 'userIds'],
    };
  },
  components: {
    StickerTab,
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser
    }),
  },
  watch: {
    page: {
      handler: function() {
        this.getData();
      },
    }
  },
  mounted() {
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const res = await StickerApi.getStickers({
          page: this.page,
          size: this.size,
          q: this.textSearch,
        })
        this.items = res.rows;
        this.count = res.count;
      } catch (err) {
        this.$bvModal.msgBoxOk(err && err.body && err.body.message || 'There is a problem getting stickers')
      }
      this.isLoading = false
    },
    search() {
      this.getData();
    },
    openAddStickerModal() {
      this.$refs["create-sticker-modal"].show();
    },

    hideAddStickerModal() {
      this.$refs["create-sticker-modal"].hide();
    },

    updateStickerForm () {
      this.conditions.forEach(condition => { 
        this.createStickerForm[condition] = this.createStickerForm.currentCondition === condition ? this.createStickerForm[condition] : ''; 
      }); 
    },

    async createSticker() {
      if (this.isCreatingSticker) return;
      this.isCreatingSticker = true
      this.createStickerForm.userId = this.currentUser.id
      try {
        this.updateStickerForm()
        await StickerApi.createSticker(this.createStickerForm)
        this.hideAddStickerModal()
        this.resetCreateForm()
        this.getData()
        utils.showToastSuccess('Success')
      } catch (e) {
        utils.showToastError(e.message || 'There is a problem creating stickers')
      } finally {
        this.isCreatingSticker = false
      }
    },

    async onChangeSticker(event) {
      let file = event.target.files[0];

      if (!file) {
        this.createStickerForm = {
          ...this.createStickerForm,
          image: '',
        }
        return
      }
      this.isCreatingSticker = true
      let formData = new FormData();
      formData.append("file", file);
      const imageUrl = await StickerApi.uploadStickerImage(formData);
      this.isCreatingSticker = false
      this.createStickerForm.image = imageUrl;
    },

    resetCreateForm() {
      this.createStickerForm = {
        name: '',
        text: '',
        buttonText: '',
        buttonUrl: '',
        image: '',
        rule: '',
        active: true,
        userId: null,
        emails: '',
        userIds: '',
        currentCondition: 'rule',
      }
    },

    editSticker(sticker) {
      this.$router.push({ name: "StickerDetail", params: { id: sticker.id} })
    },

    async deleteSticker(sticker) {
      const isConfirmed = await this.$bvModal.msgBoxConfirm(`Are you sure to remove sticker: ${sticker.name}?`)
      if (isConfirmed) {
        try {
          this.isLoading = true
          await StickerApi.deleteSticker(sticker.id)
          this.getData();
        } catch (err) {
          this.$bvModal.msgBoxOk(err && err.body && err.body.message || 'There is a problem deleting stickers')
        }
        this.isLoading = true
      }
    },
    updateCurrentCondition(value) {
      this.createStickerForm.currentCondition = value
    }
  },
};
</script>
